// Components
import Vue from 'vue'

let localApp = new Vue({})

const ui = {
  ShowError: function (title, message) {
    // localApp.$notify({
    //  group: 'foo',
    //  type: 'danger bg-danger text-white',
    //  title: title || 'Erro',
    //  text: message || 'Erro',
    //  ignoreDuplicates: true,
    //  duration: -1
    // })

    // localApp.$toast.error(message || 'Erro')

    localApp.$swal.fire({
      icon: 'error',
      title: title || 'Erro',
      text: message
    })
  },
  ShowAlert: function (title, message) {
    // localApp.$notify({
    //  group: 'foo',
    //  type: 'warning bg-warning text-white',
    //  title: title || 'Atenção',
    //  text: message || '',
    //  ignoreDuplicates: true
    // })

    // localApp.$toast.warning(message)

    localApp.$swal.fire({
      icon: 'warning',
      title: title || 'Atenção',
      text: message
    })
  },
  ShowSuccess: function (title, message, html = null) {
    // localApp.$notify({
    //  group: 'foo',
    //  type: 'bg-sucess text-white',
    //  title: title || 'Sucesso',
    //  text: message || 'Ok',
    //  ignoreDuplicates: true
    // })

    // localApp.$toast.success(message)

    localApp.$swal.fire({
      icon: 'success',
      title: title || 'Sucesso',
      text: message,
      html: html
    })
  },
  GetDecimalString: function (value) {
    if (value !== null && value !== undefined) {
      return value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    } else return null
  },
  IsDecimalString: function (value) {
    let val = value ? !isNaN(value.toString().replace(/\./g, '').replace(',', '.')) && value.toString().includes(',')
      : false
    return val
  },
  GetStringMoney: function (value) {
    if (!value) value = 0
    return value.toLocaleString('pt-br', {minimumFractionDigits: 2})
  },
  GetDecimalOrNull: function (value) {
    if (value) {
      value = value.replace(/\./g, '').replace(',', '.')
      return value ? parseFloat(value) : null
    } else return 0
  },
  GetIntOrNull: function (value) {
    return value ? parseInt(value) : null
  },
  Cep: function (value) {
    if (value) {
      value = value.toString().replace(/[^0-9]/g, '')
      if (value.length === 8) {
        const regex = /([0-9]{2})([0-9]{3})([0-9]{3})/
        const subst = `$1.$2-$3`
        return value.replace(regex, subst)
      }
    }
    return ''
  },
  Cpf: function (value) {
    if (value) {
      value = value.toString().replace(/[^0-9]/g, '')
      if (value.length === 11) {
        const regex = /([0-9]{3})([0-9]{3})([0-9]{3})([0-9{2}])/
        const subst = `$1.$2.$3-$4`
        return value.replace(regex, subst)
      }
    }
  },
  GetNumbers: (str) => str.replace(/\D/g, ''),
  isNumber: function (evt) {
    evt = (evt) || window.event
    var charCode = (evt.which) ? evt.which : evt.keyCode
    if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
      evt.preventDefault()
    } else {
      return true
    }
  }
}

export default ui



// WEBPACK FOOTER //
// ./src/_api/ui.js